import type { Locale } from "./homepage-seo.ts";

const en = {
  offline: "Offline — saved history and drafts are available. New backtests, AI and Community actions need a connection.",
  onlineRequired: "Connect to the internet to run a new backtest. Your saved history and draft remain on this device.",
  draft: "Local draft",
  saved: "Saved on this device",
  restored: "Restored from this device",
  saving: "Saving draft…",
  empty: "Changes are saved on this device for this account.",
  unavailable: "Local storage is unavailable. Keep this tab open to retain your draft.",
  clear: "Clear saved draft",
  cleared: "Saved draft cleared. Your history is unchanged.",
  notice: "Draft only — not a new backtest or server-validated result. Restorable for 30 days; never shared between accounts.",
  localHistory: "Saved historical results — not live prices or a new simulation.",
};
const vi: typeof en = {
  offline: "Đang ngoại tuyến — bạn vẫn xem được lịch sử và bản nháp đã lưu. Backtest mới, AI và thao tác Cộng đồng cần kết nối mạng.",
  onlineRequired: "Kết nối mạng để chạy backtest mới. Lịch sử và bản nháp đã lưu vẫn ở trên thiết bị này.",
  draft: "Bản nháp trên máy",
  saved: "Đã lưu trên thiết bị",
  restored: "Đã khôi phục từ thiết bị",
  saving: "Đang lưu bản nháp…",
  empty: "Thay đổi được lưu trên thiết bị này, riêng cho tài khoản hiện tại.",
  unavailable: "Không thể lưu trên thiết bị. Giữ tab này mở để không mất bản nháp.",
  clear: "Xóa bản nháp đã lưu",
  cleared: "Đã xóa bản nháp trên máy. Lịch sử vẫn được giữ nguyên.",
  notice: "Chỉ là bản nháp — chưa phải backtest mới hay kết quả được server xác nhận. Khôi phục trong 30 ngày, không dùng chung giữa các tài khoản.",
  localHistory: "Kết quả lịch sử đã lưu — không phải giá trực tiếp hay lần mô phỏng mới.",
};
const translations: Record<Locale, typeof en> = {
  en,
  vi,
  "hi": {
    offline: "ऑफ़लाइन — सहेजा गया इतिहास और ड्राफ़्ट उपलब्ध हैं। नए बैकटेस्ट, AI और कम्युनिटी की कार्रवाइयों के लिए कनेक्शन आवश्यक है।",
    onlineRequired: "नया बैकटेस्ट चलाने के लिए इंटरनेट से कनेक्ट करें। आपका सहेजा गया इतिहास और ड्राफ़्ट इसी डिवाइस पर रहते हैं।",
    draft: "स्थानीय ड्राफ़्ट",
    saved: "इस डिवाइस पर सहेजा गया",
    restored: "इस डिवाइस से बहाल किया गया",
    saving: "ड्राफ़्ट सहेजा जा रहा है…",
    empty: "बदलाव इस डिवाइस पर इसी खाते के लिए सहेजे जाते हैं।",
    unavailable: "स्थानीय स्टोरेज उपलब्ध नहीं है। अपना ड्राफ़्ट बनाए रखने के लिए यह टैब खुला रखें।",
    clear: "सहेजा गया ड्राफ़्ट हटाएँ",
    cleared: "सहेजा गया ड्राफ़्ट हटा दिया गया। आपका इतिहास अपरिवर्तित है।",
    notice: "केवल ड्राफ़्ट — नया बैकटेस्ट या सर्वर द्वारा सत्यापित परिणाम नहीं। 30 दिनों तक बहाल किया जा सकता है; खातों के बीच कभी साझा नहीं किया जाता।",
    localHistory: "सहेजे गए ऐतिहासिक परिणाम — लाइव कीमतें या नया सिमुलेशन नहीं।",
  },
  "ur": {
    offline: "آف لائن — محفوظ ہسٹری اور مسودے دستیاب ہیں۔ نئے بیک ٹیسٹ، AI کے استعمال اور کمیونٹی کی کارروائیوں کے لیے کنکشن درکار ہے۔",
    onlineRequired: "نیا بیک ٹیسٹ چلانے کے لیے انٹرنیٹ سے جڑیں۔ آپ کی محفوظ ہسٹری اور مسودہ اسی ڈیوائس پر رہتے ہیں۔",
    draft: "مقامی مسودہ",
    saved: "اس ڈیوائس پر محفوظ کیا گیا",
    restored: "اس ڈیوائس سے بحال کیا گیا",
    saving: "مسودہ محفوظ کیا جا رہا ہے…",
    empty: "تبدیلیاں اسی اکاؤنٹ کے لیے اس ڈیوائس پر محفوظ کی جاتی ہیں۔",
    unavailable: "مقامی اسٹوریج دستیاب نہیں۔ اپنا مسودہ برقرار رکھنے کے لیے یہ ٹیب کھلا رکھیں۔",
    clear: "محفوظ مسودہ حذف کریں",
    cleared: "محفوظ مسودہ حذف کر دیا گیا۔ آپ کی ہسٹری میں کوئی تبدیلی نہیں ہوئی۔",
    notice: "صرف مسودہ — نیا بیک ٹیسٹ یا سرور سے تصدیق شدہ نتیجہ نہیں۔ اسے 30 دن تک بحال کیا جا سکتا ہے؛ یہ کبھی بھی اکاؤنٹس کے درمیان شیئر نہیں کیا جاتا۔",
    localHistory: "محفوظ تاریخی نتائج — لائیو قیمتیں یا نئی سیمولیشن نہیں۔",
  },
  "th": {
    offline: "ออฟไลน์ — ประวัติและฉบับร่างที่บันทึกไว้ยังใช้งานได้ การทดสอบย้อนหลังครั้งใหม่ การใช้ AI และการดำเนินการในชุมชนต้องเชื่อมต่ออินเทอร์เน็ต",
    onlineRequired: "เชื่อมต่ออินเทอร์เน็ตเพื่อทำการทดสอบย้อนหลังครั้งใหม่ ประวัติและฉบับร่างที่บันทึกไว้ของคุณยังอยู่ในอุปกรณ์นี้",
    draft: "ฉบับร่างในอุปกรณ์",
    saved: "บันทึกไว้ในอุปกรณ์นี้แล้ว",
    restored: "กู้คืนจากอุปกรณ์นี้แล้ว",
    saving: "กำลังบันทึกฉบับร่าง…",
    empty: "การเปลี่ยนแปลงจะบันทึกไว้ในอุปกรณ์นี้สำหรับบัญชีนี้เท่านั้น",
    unavailable: "ไม่สามารถใช้พื้นที่จัดเก็บในอุปกรณ์ได้ เปิดแท็บนี้ไว้เพื่อเก็บฉบับร่างของคุณไว้",
    clear: "ล้างฉบับร่างที่บันทึกไว้",
    cleared: "ล้างฉบับร่างที่บันทึกไว้แล้ว ประวัติของคุณไม่เปลี่ยนแปลง",
    notice: "เป็นเพียงฉบับร่าง — ไม่ใช่การทดสอบย้อนหลังครั้งใหม่หรือผลลัพธ์ที่เซิร์ฟเวอร์ตรวจสอบแล้ว กู้คืนได้ภายใน 30 วัน และไม่แชร์ข้ามบัญชี",
    localHistory: "ผลลัพธ์ย้อนหลังที่บันทึกไว้ — ไม่ใช่ราคาแบบเรียลไทม์หรือการจำลองครั้งใหม่",
  },
  "bn": {
    offline: "অফলাইন — সংরক্ষিত ইতিহাস ও খসড়া উপলব্ধ আছে। নতুন ব্যাকটেস্ট চালাতে, AI ব্যবহার করতে ও কমিউনিটিতে কাজ করতে সংযোগ প্রয়োজন।",
    onlineRequired: "নতুন ব্যাকটেস্ট চালাতে ইন্টারনেটে সংযোগ করুন। আপনার সংরক্ষিত ইতিহাস ও খসড়া এই ডিভাইসেই থাকে।",
    draft: "স্থানীয় খসড়া",
    saved: "এই ডিভাইসে সংরক্ষিত",
    restored: "এই ডিভাইস থেকে পুনরুদ্ধার করা হয়েছে",
    saving: "খসড়া সংরক্ষণ করা হচ্ছে…",
    empty: "পরিবর্তনগুলো এই ডিভাইসে শুধু এই অ্যাকাউন্টের জন্য সংরক্ষিত হয়।",
    unavailable: "স্থানীয় স্টোরেজ উপলব্ধ নয়। খসড়াটি ধরে রাখতে এই ট্যাব খোলা রাখুন।",
    clear: "সংরক্ষিত খসড়া মুছুন",
    cleared: "সংরক্ষিত খসড়া মুছে ফেলা হয়েছে। আপনার ইতিহাস অপরিবর্তিত আছে।",
    notice: "শুধু খসড়া — নতুন ব্যাকটেস্ট বা সার্ভার-যাচাইকৃত ফলাফল নয়। 30 দিন পর্যন্ত পুনরুদ্ধার করা যায়; অ্যাকাউন্টগুলোর মধ্যে কখনো ভাগ করা হয় না।",
    localHistory: "সংরক্ষিত ঐতিহাসিক ফলাফল — লাইভ দাম বা নতুন সিমুলেশন নয়।",
  },
  "id": {
    offline: "Offline — riwayat dan draf tersimpan tersedia. Backtest baru, AI, dan tindakan di Komunitas memerlukan koneksi.",
    onlineRequired: "Hubungkan ke internet untuk menjalankan backtest baru. Riwayat dan draf tersimpan Anda tetap ada di perangkat ini.",
    draft: "Draf lokal",
    saved: "Disimpan di perangkat ini",
    restored: "Dipulihkan dari perangkat ini",
    saving: "Menyimpan draf…",
    empty: "Perubahan disimpan di perangkat ini khusus untuk akun ini.",
    unavailable: "Penyimpanan lokal tidak tersedia. Biarkan tab ini terbuka agar draf Anda tidak hilang.",
    clear: "Hapus draf tersimpan",
    cleared: "Draf tersimpan dihapus. Riwayat Anda tidak berubah.",
    notice: "Hanya draf — bukan backtest baru atau hasil yang telah divalidasi server. Dapat dipulihkan selama 30 hari; tidak pernah dibagikan ke akun lain.",
    localHistory: "Hasil historis tersimpan — bukan harga real-time atau simulasi baru.",
  },
  "fil": {
    offline: "Offline — makikita pa rin ang naka-save na kasaysayan at mga draft. Kailangan ng koneksyon para sa mga bagong backtest, AI at mga aksyon sa Komunidad.",
    onlineRequired: "Kumonekta sa internet para magpatakbo ng bagong backtest. Mananatili sa device na ito ang naka-save mong kasaysayan at draft.",
    draft: "Lokal na draft",
    saved: "Naka-save sa device na ito",
    restored: "Naibalik mula sa device na ito",
    saving: "Sine-save ang draft…",
    empty: "Sine-save ang mga pagbabago sa device na ito para sa account na ito.",
    unavailable: "Hindi available ang lokal na imbakan. Panatilihing bukas ang tab na ito para hindi mawala ang draft mo.",
    clear: "Burahin ang naka-save na draft",
    cleared: "Nabura ang naka-save na draft. Hindi nabago ang kasaysayan mo.",
    notice: "Draft lamang — hindi bagong backtest o resultang napatunayan ng server. Maibabalik sa loob ng 30 araw; hindi kailanman ibinabahagi sa ibang account.",
    localHistory: "Naka-save na mga dating resulta — hindi live na presyo o bagong simulation.",
  },
  "es-419": {
    offline: "Sin conexión — el historial y los borradores guardados están disponibles. Los backtests nuevos, la IA y las acciones de la Comunidad necesitan conexión.",
    onlineRequired: "Conéctate a internet para ejecutar un backtest nuevo. Tu historial y borrador guardados permanecen en este dispositivo.",
    draft: "Borrador local",
    saved: "Guardado en este dispositivo",
    restored: "Restaurado desde este dispositivo",
    saving: "Guardando borrador…",
    empty: "Los cambios se guardan en este dispositivo para esta cuenta.",
    unavailable: "El almacenamiento local no está disponible. Mantén esta pestaña abierta para conservar tu borrador.",
    clear: "Borrar borrador guardado",
    cleared: "Se borró el borrador guardado. Tu historial no cambió.",
    notice: "Solo es un borrador — no es un backtest nuevo ni un resultado validado por el servidor. Se puede restaurar durante 30 días; nunca se comparte entre cuentas.",
    localHistory: "Resultados históricos guardados — no son precios en tiempo real ni una simulación nueva.",
  },
  "pt-BR": {
    offline: "Offline — o histórico e os rascunhos salvos estão disponíveis. Novos backtests, IA e ações na Comunidade precisam de conexão.",
    onlineRequired: "Conecte-se à internet para executar um novo backtest. Seu histórico e rascunho salvos continuam neste dispositivo.",
    draft: "Rascunho local",
    saved: "Salvo neste dispositivo",
    restored: "Restaurado deste dispositivo",
    saving: "Salvando rascunho…",
    empty: "As alterações são salvas neste dispositivo para esta conta.",
    unavailable: "O armazenamento local está indisponível. Mantenha esta aba aberta para conservar seu rascunho.",
    clear: "Apagar rascunho salvo",
    cleared: "Rascunho salvo apagado. Seu histórico não foi alterado.",
    notice: "Apenas um rascunho — não é um novo backtest nem um resultado validado pelo servidor. Pode ser restaurado por 30 dias; nunca é compartilhado entre contas.",
    localHistory: "Resultados históricos salvos — não são preços em tempo real nem uma nova simulação.",
  },
  "ja": {
    offline: "オフライン — 保存済みの履歴と下書きは利用できます。新しいバックテスト、AI、コミュニティの操作には接続が必要です。",
    onlineRequired: "新しいバックテストを実行するには、インターネットに接続してください。保存済みの履歴と下書きはこの端末に残ります。",
    draft: "端末内の下書き",
    saved: "この端末に保存済み",
    restored: "この端末から復元済み",
    saving: "下書きを保存中…",
    empty: "変更内容は、このアカウント用にこの端末に保存されます。",
    unavailable: "端末内のストレージを利用できません。下書きを保持するには、このタブを開いたままにしてください。",
    clear: "保存済みの下書きを削除",
    cleared: "保存済みの下書きを削除しました。履歴は変更されていません。",
    notice: "下書きのみ — 新しいバックテストやサーバーで検証済みの結果ではありません。30日間は復元でき、アカウント間で共有されることはありません。",
    localHistory: "保存済みの過去の結果 — リアルタイムの価格や新しいシミュレーションではありません。",
  },
  "ko": {
    offline: "오프라인 — 저장된 기록과 초안은 사용할 수 있습니다. 새 백테스트, AI 및 커뮤니티 작업에는 연결이 필요합니다.",
    onlineRequired: "새 백테스트를 실행하려면 인터넷에 연결하세요. 저장된 기록과 초안은 이 기기에 남아 있습니다.",
    draft: "기기 내 초안",
    saved: "이 기기에 저장됨",
    restored: "이 기기에서 복원됨",
    saving: "초안 저장 중…",
    empty: "변경 사항은 이 계정용으로 이 기기에 저장됩니다.",
    unavailable: "기기 내 저장소를 사용할 수 없습니다. 초안을 유지하려면 이 탭을 열어 두세요.",
    clear: "저장된 초안 지우기",
    cleared: "저장된 초안을 지웠습니다. 기록은 변경되지 않았습니다.",
    notice: "초안일 뿐, 새 백테스트나 서버에서 검증된 결과가 아닙니다. 30일 동안 복원할 수 있으며 계정 간에 공유되지 않습니다.",
    localHistory: "저장된 과거 결과 — 실시간 가격이나 새 시뮬레이션이 아닙니다.",
  },
  "ru": {
    offline: "Нет подключения — сохранённая история и черновики доступны. Для новых бэктестов, ИИ и действий в сообществе нужно подключение.",
    onlineRequired: "Подключитесь к интернету, чтобы запустить новый бэктест. Сохранённая история и черновик останутся на этом устройстве.",
    draft: "Локальный черновик",
    saved: "Сохранено на этом устройстве",
    restored: "Восстановлено с этого устройства",
    saving: "Сохранение черновика…",
    empty: "Изменения сохраняются на этом устройстве для этого аккаунта.",
    unavailable: "Локальное хранилище недоступно. Не закрывайте эту вкладку, чтобы сохранить черновик.",
    clear: "Удалить сохранённый черновик",
    cleared: "Сохранённый черновик удалён. История не изменилась.",
    notice: "Только черновик — не новый бэктест и не результат, проверенный сервером. Доступен для восстановления в течение 30 дней; никогда не передаётся между аккаунтами.",
    localHistory: "Сохранённые исторические результаты — не цены в реальном времени и не новая симуляция.",
  },
  "tr": {
    offline: "Çevrimdışı — kayıtlı geçmiş ve taslaklar kullanılabilir. Yeni geriye dönük testler, yapay zekâ ve Topluluk işlemleri için bağlantı gerekir.",
    onlineRequired: "Yeni bir geriye dönük test çalıştırmak için internete bağlanın. Kayıtlı geçmişiniz ve taslağınız bu cihazda kalır.",
    draft: "Yerel taslak",
    saved: "Bu cihaza kaydedildi",
    restored: "Bu cihazdan geri yüklendi",
    saving: "Taslak kaydediliyor…",
    empty: "Değişiklikler bu hesap için bu cihazda kaydedilir.",
    unavailable: "Yerel depolama kullanılamıyor. Taslağınızı korumak için bu sekmeyi açık tutun.",
    clear: "Kayıtlı taslağı sil",
    cleared: "Kayıtlı taslak silindi. Geçmişiniz değişmedi.",
    notice: "Yalnızca taslaktır; yeni bir geriye dönük test veya sunucu tarafından doğrulanmış sonuç değildir. 30 gün boyunca geri yüklenebilir; hesaplar arasında asla paylaşılmaz.",
    localHistory: "Kayıtlı geçmiş sonuçlar — canlı fiyatlar veya yeni bir simülasyon değildir.",
  },
  "uk": {
    offline: "Немає з’єднання — збережена історія та чернетки доступні. Для нових бектестів, ШІ й дій у спільноті потрібне з’єднання.",
    onlineRequired: "Підключіться до інтернету, щоб запустити новий бектест. Збережена історія та чернетка залишаться на цьому пристрої.",
    draft: "Локальна чернетка",
    saved: "Збережено на цьому пристрої",
    restored: "Відновлено з цього пристрою",
    saving: "Збереження чернетки…",
    empty: "Зміни зберігаються на цьому пристрої для цього облікового запису.",
    unavailable: "Локальне сховище недоступне. Не закривайте цю вкладку, щоб зберегти чернетку.",
    clear: "Видалити збережену чернетку",
    cleared: "Збережену чернетку видалено. Історія не змінилася.",
    notice: "Лише чернетка — не новий бектест і не результат, перевірений сервером. Можна відновити протягом 30 днів; ніколи не передається між обліковими записами.",
    localHistory: "Збережені історичні результати — не ціни в реальному часі й не нова симуляція.",
  },
};

export function localSupportT(locale: string, key: keyof typeof en): string {
  const language = locale.trim().replace(/_/g, "-").toLowerCase().split("-")[0];
  const selected = language === "pt" ? "pt-BR" : language === "es" ? "es-419" : language;
  return translations[selected as Locale]?.[key] ?? en[key];
}
